import React, {useState} from 'react';
import {Form, Icon, Input, Button} from 'antd';
import {FormattedMessage, injectIntl} from 'react-intl';

type Props = {
    resetPasswordRequest: (data: object) => void;
    id: string;
    form: any;
    intl: any;
    history: any;
}

const ResetPasswordForm: React.FC<Props> = props => {
    const {form, intl, resetPasswordRequest, id, history} = props;
    const {formatMessage} = intl;
    const {getFieldDecorator} = form;

    const [request, setRequest] = useState({
        loading: false,
        error: false
    });

    const [sendEmail, setSendEmail] = useState(false);

    const showError = error => {
        setRequest({
            loading: false,
            error: true
        });
    };

    const handleSubmit = e => {
        e.preventDefault();
        if (request.loading) {
            return
        }
        form.validateFields((err, values) => {
            if (!err) {
                setRequest({
                    loading: true,
                    error: false
                });

                resetPasswordRequest({
                    payload: values,
                    params: {id: id},
                    onErrorCallback: showError,
                    onSuccessCallback: () => {
                        setSendEmail(true);
                    }
                })
            }
        });
    };

    const redirectToLoginPage = () => {
        history.push('/login');
    }

    return (
        <Form onSubmit={handleSubmit} className="login-form">
            <div>
                <h2 className={`form-title`}>
                    <FormattedMessage id="app.reset_password" defaultMessage={`Reset Password`}/>
                </h2>
            </div>
            <Form.Item>
                {getFieldDecorator('email', {
                    rules: [{
                        type: 'email',
                        message: <FormattedMessage id="app.invalid_email"
                                                   defaultMessage={`The input is not valid E-mail!`}/>,
                    }, {
                        whitespace: true,
                        required: true,
                        message: <FormattedMessage id="app.enter_email" defaultMessage={`Please enter your email!`}/>
                    }],
                })(
                    <Input
                        size={`large`}
                        prefix={<Icon type="mail" style={{color: 'rgba(0,0,0,.25)'}}/>}
                        placeholder={
                            formatMessage({
                                id: "app.email",
                                defaultMessage: "Email",
                            })}
                    />,
                )}
            </Form.Item>
            <Form.Item>
                <Button size={`large`} type="primary" htmlType="submit" className="login-form-button"
                        loading={request.loading}>
                    <FormattedMessage
                        id="app.send_reset_password_link"
                        defaultMessage={`Send Reset Password Link To Email`}/>
                </Button>
            </Form.Item>
            <Form.Item>
                <Button
                    size={`large`}
                    type="primary"
                    className="login-form-button"
                    onClick={redirectToLoginPage}
                    loading={request.loading}>
                    <FormattedMessage
                        id="app.come_back_to_login_page"
                        defaultMessage={`Come Back To Login Page`}/>
                </Button>
            </Form.Item>

            {/*//Show Error Message*/}
            {request.error && (
                <div>
                    <p className={`error-message`}>
                        <FormattedMessage
                            id="app.wrong_email"
                            defaultMessage={`The Email is not correct!`}/>
                    </p>
                </div>
            )}
            {/*//Show Success Message*/}
            {sendEmail && (
                <div className="success-message-wrap">
                    <span>
                        <FormattedMessage
                            id="app.success_send_reset_password_link"
                            defaultMessage={`Reset password link has been send successfully.please check your email.`}/>
                    </span>
                </div>
            )}

        </Form>
    );
};

export default Form.create({name: 'login_login'})(injectIntl(ResetPasswordForm));